"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * LiBat Gestion
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAttachmentToJSON = exports.IAttachmentFromJSONTyped = exports.IAttachmentFromJSON = void 0;
function IAttachmentFromJSON(json) {
    return IAttachmentFromJSONTyped(json, false);
}
exports.IAttachmentFromJSON = IAttachmentFromJSON;
function IAttachmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'originalName': json['originalName'],
    };
}
exports.IAttachmentFromJSONTyped = IAttachmentFromJSONTyped;
function IAttachmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'originalName': value.originalName,
    };
}
exports.IAttachmentToJSON = IAttachmentToJSON;
